import { gql } from '@apollo/client';

export const CREATE_GREASE_TRAP = gql`
  mutation CreateGreaseTrap(
    $vendor_id: ID!
    $driver_id: ID!
    $truck_id: ID!
    $location_id: ID!
    $gross_pounds: Float!
    $gallons_grease_received: Float!
    $traceability: Boolean
    $registered_by: ID!
  ) {
    createGreaseTrap(
      vendor_id: $vendor_id
      driver_id: $driver_id
      truck_id: $truck_id
      location_id: $location_id
      gross_pounds: $gross_pounds
      gallons_grease_received: $gallons_grease_received
      traceability: $traceability
      registered_by: $registered_by
    ) {
      id
    }
  }
`;

export const UPDATE_GREASE_TRAP = gql`
  mutation UpdateVendorGreaseTrap($id: ID!, $key: String!, $value: String!) {
    updateVendorGreaseTrap(id: $id, key: $key, value: $value) {
      id
      status
      total_amount
    }
  }
`;

export const DELETE_GREASE_TRAP = gql`
  mutation DeleteVendorGreaseTrap($id: ID!) {
    deleteVendorGreaseTrap(id: $id)
  }
`;

export const CREATE_GTW_PAYMENT = gql`
  mutation CreateVendorGreaseTrapPayment($greaseTrapId: ID!) {
    createVendorGreaseTrapPayment(greaseTrapId: $greaseTrapId) {
      id
      grease_trap_id
    }
  }
`;

export const UPDATE_GTW_PAYMENT = gql`
  mutation UpdateVendorGreaseTrapPayment(
    $id: ID!
    $key: String!
    $value: String!
  ) {
    updateVendorGreaseTrapPayment(id: $id, key: $key, value: $value) {
      id
      amount
      payment_type
      check_number
      transaction_number
      paid_at
    }
  }
`;
